import getAudienceDefinitions from 'common/lib/experiments/audience-definitions';
import CollapsedTest from 'common/lib/experiments/collapsed-test';
import SimpleTest from 'common/lib/experiments/simple-test';
import { Member } from 'common/lib/experiments/types';
import Token from 'common/lib/util/token';
import { Store } from 'redux';
import { getMe } from 'selectors/members';
import { State } from '../modules';

const testCache: { [key: string]: CollapsedTest } = {};

class Experiment {
  get: (testName: string, identifier?: string) => CollapsedTest;
  audienceDefinitions: ReturnType<typeof getAudienceDefinitions>;
  setStore(store: Store<State>) {
    const getMember = () => getMe(store.getState()) as Member;
    this.audienceDefinitions = getAudienceDefinitions(getMember);
    const simpleTest = new SimpleTest(this.audienceDefinitions);

    this.get = function(testName: string, identifier?: string) {
      const id = identifier || Token.getMyId() || 'notLoggedIn';
      const key = [testName, id].filter((a) => a).join(':');
      if (!testCache[key]) {
        testCache[key] = simpleTest.getParams(testName, id);
      }

      return testCache[key];
    };
  }
}

const experiment = new Experiment();
export default experiment;



// WEBPACK FOOTER //
// ./app/gamma/src/util/experiments.ts